import { Heading } from '@lululemon/b2b-ecom-pattern-library';
import cs from 'classnames';
import styles from './legal-page.module.scss';
import { renderedText } from './utils';

export type LegalPageIntProps = {
  heading: string;
  subHeading?: string;
  lastUpdatedDate?: string;
  startIndex?: number;
  mainContentSection?: {
    mainSectionContent: string;
  }[];
  legalSection?: {
    legalSectionId?: string;
    legalSectionHeading: string;
    legalSectionContent?: string;
    legalSubsection?: {
      legalSubsectionId?: string;
      legalSubsectionHeading: string;
      legalSubsectionContent?: string;
    }[];
  }[];
};

const LegalPageInt = (data: LegalPageIntProps) => {
  const { heading, subHeading, lastUpdatedDate, mainContentSection, legalSection, startIndex = 1 } = data;

  return (
    <div className={styles.container} data-testid="legal-page_test-id">
      <div
        className={
          heading === 'n/a'
            ? cs('lll-grid lll-grid-padding', styles.gridContainer)
            : cs('lll-grid lll-grid-padding', styles.gridContainer, styles.headerMargin)
        }
      >
        {heading !== 'n/a' && (
          <Heading
            data-testid="legal-page__heading_test-id"
            wrapperClassName={styles.heading}
            className="lll-type-heading-extra-small"
            tag="h1"
          >
            {heading}
          </Heading>
        )}
        {subHeading !== 'n/a' && (
          <Heading
            data-testid="legal-page__subheading_test-id"
            wrapperClassName={styles.subHeading}
            className="lll-type-heading-extra-small"
            tag="h1"
          >
            {subHeading}
          </Heading>
        )}
        {lastUpdatedDate && (
          <div data-testid="legal-page__date_test-id" className={styles.lastUpdatedDate}>
            {lastUpdatedDate}
          </div>
        )}
        <div className={styles.contentContainer}>
          {mainContentSection && mainContentSection[0].mainSectionContent && (
            <div data-testid="legal-page__main-content_test-id" className={styles.contentText}>
              {renderedText(mainContentSection[0].mainSectionContent)}
            </div>
          )}
          {legalSection && (
            <ol className={styles.legalSectionList} start={startIndex}>
              {legalSection
                .slice(0, 25)
                .map(({ legalSectionHeading, legalSectionContent, legalSectionId, legalSubsection }, index) => (
                  <li id={legalSectionId} key={index} className={styles.legalSectionItem}>
                    {legalSectionHeading && (
                      <h2
                        data-testid={`legal-page__section-heading-${index}_test-id`}
                        className={cs('lll-type-label-button', styles.sectionHeading, styles.sectionHeadingUnderline)}
                      >
                        {legalSectionHeading}
                      </h2>
                    )}
                    {legalSectionContent && (
                      <div data-testid={`legal-page__section-content-${index}_test-id`} className={styles.contentText}>
                        {renderedText(legalSectionContent)}
                      </div>
                    )}
                    {legalSubsection && (
                      <ol type="a" className={styles.legalSubsectionList}>
                        {legalSubsection.map(
                          ({ legalSubsectionHeading, legalSubsectionContent, legalSubsectionId }, index) => (
                            <li id={legalSubsectionId} key={index} className={styles.legalSubsectionItem}>
                              <h3
                                data-testid={`legal-page__subsection-heading-${index}_test-id`}
                                className={cs('lll-text-subtitle', styles.subsectionHeading)}
                              >
                                {legalSubsectionHeading}
                              </h3>
                              {legalSubsectionContent && (
                                <div
                                  data-testid={`legal-page__subsection-content-${index}_test-id`}
                                  className={styles.contentText}
                                >
                                  {renderedText(legalSubsectionContent)}
                                </div>
                              )}
                            </li>
                          ),
                        )}
                      </ol>
                    )}
                  </li>
                ))}
            </ol>
          )}
        </div>
      </div>
    </div>
  );
};

export default LegalPageInt;
